// extracted by css-extract-rspack-plugin
export default {"separator":"PYdJJ","column":"OHLfP","dropdown":"jMZSR","placeholder":"Bqaax"};